import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminTicketService } from '@/modules/ticket/services/admin-ticket.service'
import { TicketResourceModel } from '@/modules/ticket/models/ticket-resource.model'
import { TicketUpdateRequestModel } from '@/modules/ticket/models/ticket-request.model'
import { PersonTitle } from '@/modules/common/person/models/PersonResource.model'

@vservice()
export class TicketSettingUpdateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminTicketService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(ticketId: number, data: TicketResourceModel) {
    return this.service.update(ticketId, this.requestData(data))
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

  requestData(data): TicketUpdateRequestModel {
    return {
      admin_note: data.admin_note || '',
      department_id: data.department.id,
      last_answer_date: data.last_answer_date,
      status: data.status,
      title: data.title || '',
      person: data.zone || PersonTitle.USER
    }
  }

}
